export default __webpack_public_path__ + "static/media/1.ff0f453b.jpg";